import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';

import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/modules/shared/services/util.service';

@Injectable({
  providedIn: 'root'
})
export class PushNotificationService {

  constructor(
    private _router: Router,
    private _utilService: UtilService,
    private _httpClient: HttpClient
  ) { }

  // Get push notification campaigns
  getPushNotificationCampaigns(token: string, retailerId: string, page: any){
    const URL = environment.apiUrl + 'dashboard/pushNotificationCampaigns';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqParams = new HttpParams()
      .set('retailer_id', retailerId)
      .set('page', page);

    return this._httpClient.get<any>(URL, {headers: reqHeaders, params: reqParams});
  }

  // Get push notification topics
  getPushNotificationTopics(token: string, retailerId: string){
    const URL = environment.apiUrl + 'dashboard/pushNotificationTopics';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqParams = new HttpParams()
      .set('retailer_id', retailerId);

    return this._httpClient.get<any>(URL, {headers: reqHeaders, params: reqParams});
  }

  // Create push notification campaign
  createPushNotificationCampaign(token: string, body: any){
    const URL = environment.apiUrl + 'dashboard/createPushNotificationCampaign';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqBody = JSON.stringify(body);

    return this._httpClient.post<any>(URL, reqBody, {headers: reqHeaders});
  }

  // Edit push notification campaign
  updatePushNotificationCampaign(token: string, body: any){
    const URL = environment.apiUrl + 'dashboard/updatePushNotificationCampaign';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqBody = JSON.stringify(body);

    return this._httpClient.post<any>(URL, reqBody, {headers: reqHeaders});
  }

  // Cancel push notification campaign
  cancelPushNotificationCampaign(token: string, body: any){
    const URL = environment.apiUrl + 'dashboard/cancelPushNotificationCampaign';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqBody = JSON.stringify(body);

    return this._httpClient.post<any>(URL, reqBody, {headers: reqHeaders});
  }

}
